import { ComponentPropsWithoutRef } from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';
import { Dialog, DialogOverlay, DialogContent } from '@reach/dialog';

import { c07071D, cBC44FF } from '#/colors';

export type ModalProps = ComponentPropsWithoutRef<typeof Dialog>;

export default function Modal(props: ModalProps) {
  const { isOpen, onDismiss, children, ...rest } = props;
  return (
    <StyledDialogOverlay isOpen={isOpen} onDismiss={onDismiss}>
      <StyledDialogContent {...rest}>{children}</StyledDialogContent>
    </StyledDialogOverlay>
  );
}

const StyledDialogOverlay = styled(DialogOverlay)`
  z-index: 1;
  backdrop-filter: blur(6px);
  background: ${rgba('#080018', 0.5)};
`;

const StyledDialogContent = styled(DialogContent)`
  width: 400px;
  border-radius: 10px;
  background-color: ${c07071D};
  box-shadow: 0 2px 50px 0 ${rgba(cBC44FF, 0.3)};
  padding: 20px;
`;
